import { render, staticRenderFns } from "./SpecialRfDgUploadPop.vue?vue&type=template&id=a4048da4"
import script from "./SpecialRfDgUploadPop.vue?vue&type=script&lang=js"
export * from "./SpecialRfDgUploadPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4048da4')) {
      api.createRecord('a4048da4', component.options)
    } else {
      api.reload('a4048da4', component.options)
    }
    module.hot.accept("./SpecialRfDgUploadPop.vue?vue&type=template&id=a4048da4", function () {
      api.rerender('a4048da4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/SpecialRfDgUploadPop.vue"
export default component.exports